import { TOfferCategory } from '../types/offer';

export const VILLAGE_OFFER_CATEGORY_MAP: { [index: string]: string } = {
  houseSale: 'Дом',
  landSale: 'Участок',
  townhouseSale: 'Таунхаус',
  cottageSale: 'Коттедж',
};

export function getVillageOfferCategoryLabel(category: TOfferCategory | undefined) {
  return category && VILLAGE_OFFER_CATEGORY_MAP[category] || 'Объект';
}
